module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Menu-074f0d818b0be074547a13ba030b7490.svg";